import FooterSimple from './FooterSimple';

export default FooterSimple;
